import { render } from "./hr-question-factory.vue?vue&type=template&id=ef64f29c"
import script from "./hr-question-factory.vue?vue&type=script&lang=js"
export * from "./hr-question-factory.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__